<template lang="pug">
.v-field-view-picker.view-picker
	.view-picker__title-wrapper
		.view-picker__title(v-if="field.title") {{field.title}}:
		.view-picker__title-selected {{displayedText}}
	.view-picker__grid-wrapper
		.view-picker__grid
			template(v-if="field.options && field.options.length"
					v-for="(option, index) in field.options"
					:key="index")
				template(v-if="option.disabled")
					button.view-picker__item(disabled
							@mouseover="displayOptionText(option.text)"
							@mouseleave="resetDisplayedText")
						.view-picker__icon.view-picker__icon--disabled(:style="getIconStyle(option)")
				template(v-else)
					button.view-picker__item.view-picker__item--enable(:key="index"
							type="button"
							:aria-label="`Цвет ${option.text}`"
							:class="{'view-picker__item--active': option.value === modelValue[0]}"
							@click="$emit('update:model-value', option.value)"
							@mouseover="displayOptionText(option.text)"
							@mouseleave="resetDisplayedText")
						.view-picker__icon(:style="getIconStyle(option)")
</template>

<script>
import controller from '../scripts/controller/controller.js';

export default {
	props: {
		field: {
			type: Object,
			default: null
		},

		modelValue: {
			type: [Array, String],
			default: () => []
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			selectedText: '',
			displayedText: ''
		};
	},

	created() {
		this.updateDisplayedText();
	},

	methods: {
		updateDisplayedText() {
			const selectedOption = this.field.options.find(option => option.value === this.modelValue[0]);
			if (selectedOption) {
				this.selectedText = this.formatText(selectedOption.text);
			} else {
				this.selectedText = '';
			}
			this.displayedText = this.selectedText;
		},

		getIconStyle(option) {
			if (option && option.color) {
				if (Array.isArray(option.color) && option.color.length === 2) {
					return {
						background: `linear-gradient(90deg, ${option.color[0]} 50%, ${option.color[1]} 30%)`
					};
				} else if (Array.isArray(option.color) && option.color.length === 1) {
					return {
						backgroundColor: option.color[0]
					};
				} else if (typeof option.color === 'string') {
					return {
						backgroundColor: option.color
					};
				}
			}
			return {};
		},

		formatText(text) {
			if (Array.isArray(text)) {
				return text.join(' / ');
			}
			return text || '';
		},

		displayOptionText(text) {
			this.displayedText = this.formatText(text);
		},

		resetDisplayedText() {
			this.displayedText = this.selectedText;
		}
	}
};
</script>
